import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { signupActions } from "~/services/signup";
import { useMount } from "~/services/utils/hooks";
import LandingTemplate from "~/templates/LandingV2";
import usePricing from "~/components/usePricing";
import { Translation, LocalizedCurrency } from "~/components/Translation";
var FriendLandingTemplate = function(param) {
    var image = param.image, name = param.name, referrerClick = param.referrerClick, referrerId = param.referrerId;
    var referralPricing = usePricing().referralPricing;
    // Save that user signed up through this page
    useMount(function() {
        referrerClick({
            referrer: referrerId,
            referrerType: "affiliate"
        });
    });
    return /*#__PURE__*/ _jsx(LandingTemplate, {
        heading: /*#__PURE__*/ _jsx(Translation, {
            tid: "landing.title"
        }),
        recommendedBy: {
            image: image,
            text: /*#__PURE__*/ _jsx(Translation, {
                tid: "landing.partners.referrerDescription",
                values: {
                    name: name
                },
                components: {
                    creditAmount: /*#__PURE__*/ _jsx(LocalizedCurrency, {
                        value: referralPricing.referredCredit,
                        minimumFractionDigits: 0
                    })
                }
            })
        },
        subHeading: /*#__PURE__*/ _jsx(Translation, {
            tid: "landing.subtitle.v2"
        })
    });
};
FriendLandingTemplate.propTypes = {
    image: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    name: PropTypes.string.isRequired,
    referrerClick: PropTypes.func.isRequired,
    referrerId: PropTypes.string.isRequired
};
var mapDispatchToProps = {
    referrerClick: signupActions.referrerClick
};
export default connect(null, mapDispatchToProps)(FriendLandingTemplate);
